import React from 'react';
import { Navigate, Outlet, useLocation, useParams } from 'react-router-dom';
import { useStorefrontAuth } from '../../auth/context/StorefrontAuthContext';
import { PortalShellSkeleton } from '../../../components/loading/skeletons';

const ProtectedStorefrontClientPortalRoute = () => {
  const { storefrontClient, sessionUser, hasPortalAccess, loading } = useStorefrontAuth();
  const location = useLocation();
  const { companyUrl } = useParams();

  if (loading) {
    return <PortalShellSkeleton label="Loading portal" />;
  }

  if (!sessionUser || !hasPortalAccess || !storefrontClient) {
    const loginTarget = companyUrl ? `/book/${companyUrl}/login` : '/app/login';
    return (
      <Navigate
        to={loginTarget}
        replace
        state={{
          from: location.pathname
        }}
      />
    );
  }

  return <Outlet />;
};

export default ProtectedStorefrontClientPortalRoute;
